// removed by extract-text-webpack-plugin
module.exports = {"block":"_1yyxvkDr9bAZG-Dprz36u7","inner":"_26qxwzSZS_yDaOwhovpwQX","heading":"_3EcrQrILMWnD_jrEtdjpzZ","intro":"_3JUpGocdQuYM7V-H05MCFo","links":"_1jVkzBa87n-AZrIXFBWSJN","links-item":"_3bNkeq-5R6-qTL6GnE7X7d","link":"_3RML2PHqxjXG7k_X2PLeS2","link-icon":"_2EXmZLlfq96eXYDMGWXWLS","link-text":"_2glpqclFRk1sySQXc3vvox"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BusinessAreaBlock/BusinessAreaBlock.module.scss
// module id = 737
// module chunks = 0